"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const m49 = require("../m49/m49-impl");
const numeric_1 = require("../numeric");
const trace = false;
let all;
let all_index;
const fields = ['1-alpha2', '1-alpha3', '1-num3'];
function build() {
    if (all == null) {
        trace && console.time('ISO3166 db');
        all_index = {};
        const dep = require('countries-code').allCountriesList();
        all = dep.map((depData) => {
            const isoData = {
                name_en: depData.country_name_en,
                '1-alpha2': depData.alpha2,
                '1-alpha3': depData.alpha3,
                '1-num3': depData['number']
            };
            const m49data = m49.find(isoData['1-num3']);
            if (m49data) {
                isoData['1-num3-m49'] = m49data;
            }
            for (let i = 0; i < fields.length; ++i) {
                const field = isoData[fields[i]];
                if (field) {
                    const value = field.toLowerCase();
                    if (value) {
                        if (trace) {
                            const previous_entry = all_index[value];
                            if (previous_entry && (isoData !== previous_entry)) {
                                trace && console.error(`ISO3166 ${isoData} conflicts with ${previous_entry}`);
                            }
                        }
                        all_index[value] = isoData;
                    }
                }
            }
            return isoData;
        });
        trace && console.timeEnd('ISO3166 db');
    }
}
function getList() {
    build();
    return all;
}
exports.getList = getList;
function find(data) {
    build();
    let dataC;
    if (numeric_1.isNumeric(data)) {
        dataC = numeric_1.padLeft('000', data);
    }
    else {
        dataC = data.toLowerCase();
    }
    const isoData = all_index[dataC];
    return isoData;
}
exports.find = find;
//# sourceMappingURL=iso-3166-impl.js.map